<template>
  <el-row :gutter="15" class="wrapper">
    <el-col :md="6">
      <div class="card section">
        <p class="page-title">送货中订单数</p>
        <div class="content">
          <div class="item">
            <bean-link :to="{ name: 'orders.index', query: { deliveries_state_eq: 'delivering' } }">
              <p class="value">{{ data.order_delivery_delivering_count }}</p>
            </bean-link>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :md="6">
      <div class="card section">
        <p class="page-title">待质检订单数</p>
        <div class="content">
          <div class="item">
            <bean-link :to="{ name: 'orders.index', query: { deliveries_state_eq: 'reached' } }">
              <p class="value">{{ data.order_delivery_reached_count }}</p>
            </bean-link>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :md="6">
      <div class="card section">
        <p class="page-title">退厂返工订单数</p>
        <div class="content">
          <div class="item">
            <bean-link :to="{ name: 'orders.index', query: { deliveries_state_eq: 'failed' } }">
              <p class="value">{{ data.order_delivery_failed_count }}</p>
            </bean-link>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class QualityInspector extends Vue {
  data = {
    order_delivery_delivering_count: 0,
    order_delivery_reached_count: 0,
    order_delivery_failed_count: 0
  };

  async mounted() {
    this.data = await this.$request.get('/dashboard/quality_inspector')
  }
}
</script>
